<template>
  <v-card>
    <v-img :src="src" height="200" contain></v-img>
    <v-card-title>
      {{ qDoc.qDocName }}
    </v-card-title>
    <v-card-actions>
      <v-btn block color="primary" @click="$emit('connect')">
        <v-icon left>link</v-icon>
        {{$t('Global.Action.connect')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { getAppImgSrc } from '@portal/qlik'
export default {
  name: 'QlikAppCard',
  props: {
    qDoc: { type: Object, required: true }
  },
  computed: {
    src () {
      return getAppImgSrc(this.qDoc.qThumbnail.qUrl)
    }
  }
}
</script>